import React from 'react';
import Icon from '@ant-design/icons';
import { Button } from 'antd';
import { ActionBar, StyledEllipsis, StyledEllipsisTooltip, StyledRootCell } from './styled';
import { useRCADrilldown } from '../hooks/useRCADrilldown';
import OpenOutIcon from '@icons/common/open-out.svg';

const actions = [
  // { label: <CopyOutlined />, value: 'copy' },
  { label: <Icon component={OpenOutIcon} />, value: 'diagnose' },
];

function Actions({ actions, handleActions }) {
  return (
    <ActionBar className="action-bar">
      {actions.map((action) => {
        return (
          <Button
            key={action.value}
            type="text"
            icon={action.label}
            onClick={handleActions(action.value)}
          />
        );
      })}
    </ActionBar>
  );
}

function RootCell({ cellData, column, rowData }) {
  const { handleDrilldown } = useRCADrilldown({ rowData });

  const handleActions = (value) => {
    // if (value === 'copy') {
    //   return () => {
    //     if (copy(cellData)) {
    //       message.info('Copied to clipboard');
    //     }
    //   };
    // }
    if (value === 'diagnose') {
      return handleDrilldown;
    }
    return () => null;
  };

  return (
    <StyledRootCell>
      <StyledEllipsis style={{ pointerEvents: 'none' }}>
        <StyledEllipsisTooltip text={cellData} />
      </StyledEllipsis>
      <Actions actions={actions} handleActions={handleActions} />
    </StyledRootCell>
  );
}

export default RootCell;
